import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/widgets/Footer/ui/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/widgets/Header/ui/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/widgets/Header/ui/HeaderButtons/HeaderButtonsDefault.tsx");
